<template>
  <div
    class="w-24 h-24 bg-tertiary-100 rounded-md mt-2 mr-2 animate-pulse"
  ></div>
</template>
